<template>
  <v-dialog
    v-model="isOpen"
    :width="width"
    @click:outside="outsideClick"
  >
    <v-card>
      <v-card-title>
        <v-icon
          class="mr-2"
          :color="getColor"
        >
          {{ getIcon }}
        </v-icon>
        {{ getHeader }}
      </v-card-title>
      <v-card-text class="mt-2">
        {{ getContent }}
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="closePushed"
        >
          {{ $t("dialog.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      width: 500,
    };
  },
  computed: {
    isOpen() {
      return this.open;
    },
    getHeader() {
      return this.header;
    },
    getContent() {
      return this.content;
    },
    getColor() {
      if (this.type.includes("warning")) {
        return "orange";
      } else if (this.type.includes("error")) {
        return "red";
      } else {
        return "blue";
      }
    },
    getIcon() {
      if (this.type.includes("warning")) {
        return "mdi-alert";
      } else if (this.type.includes("error")) {
        return "mdi-alert-circle";
      } else {
        return "mdi-information";
      }
    },
  },
  methods: {
    closePushed() {
      this.$emit("close-pushed");
    },
    outsideClick() {
      this.$emit("close-pushed");
    },
  },
};
</script>

<style></style>
